import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  OAuthProvider, 
  FacebookAuthProvider, 
  signInAnonymously,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  fetchSignInMethodsForEmail,
  EmailAuthProvider,
  linkWithCredential
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

function resolveFirestoreDatabaseId() {
  if (typeof window !== "undefined" && window.location?.hostname) {
    const host = window.location.hostname.toLowerCase();
    if (
      host === "we360-dev.web.app" ||
      host === "we360-dev.firebaseapp.com" ||
      host === "we360.saluddigital360.com" ||
      host === "we360-dev.saluddigital360.com"
    ) {
      return "we360-dev";
    }
    if (
      host === "we360-486203.web.app" ||
      host === "we360-486203.firebaseapp.com" ||
      host === "we360-stg.saluddigital360.com"
    ) {
      return "(default)";
    }
  }
  return process.env.REACT_APP_FIRESTORE_DATABASE_ID || "(default)";
}

export const resolvedFirestoreDatabaseId = resolveFirestoreDatabaseId();
export const db = resolvedFirestoreDatabaseId && resolvedFirestoreDatabaseId !== "(default)"
  ? getFirestore(app, resolvedFirestoreDatabaseId)
  : getFirestore(app);

export const storage = getStorage(app);

export const googleProvider = new GoogleAuthProvider();
export const microsoftProvider = new OAuthProvider("microsoft.com");
export const facebookProvider = new FacebookAuthProvider();

// Email/Password exports
export { 
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  fetchSignInMethodsForEmail,
  EmailAuthProvider,
  linkWithCredential
};
